// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/HorizontalButtonSlider/horizontalbuttonslider.css
// module id = 1019
// module chunks = 0